import request from '@/utils/request'

// 成品检验报表
export function apiGetFinishedProductInspectionReport (query) {
  return request({
    url: `/inv/invFinishedProductInspection/getFinishedProductInspectionReport`,
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiExportFinishedProductInspectionReport (query) {
  return request({
    url: '/inv/invFinishedProductInspection/v2/exportFinishedProductInspectionReport',
    method: 'get',
    params: query
  })
}

// 成品不良率报表列表
export function apiFinishedProductDefectRateReportList (data) {
  return request({
    url: '/mes/mesDiscreteJobs/finishedProductDefectRateReportList',
    method: 'post',
    data: data
  })
}

// 成品不良率报表列表导出
export function apiFinishedProductDefectRateReportListExport (data) {
  return request({
    url: '/mes/mesDiscreteJobs/finishedProductDefectRateReportListExport',
    method: 'post',
    data: data
  })
}

// 成品不良原因报表列表
export function apiFinishedProductDefectReasonReportList (data) {
  return request({
    url: '/mes/mesDiscreteJobs/finishedProductDefectReasonReportList',
    method: 'post',
    data: data
  })
}

// 成品不良原因报表列表导出
export function apiFinishedProductDefectReasonReportListExport (data) {
  return request({
    url: '/mes/mesDiscreteJobs/finishedProductDefectReasonReportListExport',
    method: 'post',
    data: data
  })
}

// 查询不良类别
export function apiSearchBadCauseClass (query) {
  return request({
    url: '/mes/pda/searchBadCauseClass',
    method: 'get',
    params: query
  })
}

// 查询一级不良原因
export function apiSearchBadCauseFirst (query) {
  return request({
    url: '/mes/pda/searchBadCauseFirst',
    method: 'get',
    params: query
  })
}

// 查询二级不良原因
export function apiSearchBadCauseSecond (query) {
  return request({
    url: '/mes/pda/searchBadCauseSecond',
    method: 'get',
    params: query
  })
}
